import { dataService } from '../dataService';
import { ENTITY_TYPES } from '../../db';
import { productApi, customersApi, accountsApi, orgApi, expensesApi, businessAccountsApi } from '../../api';

const DEFAULT_STALE_TIME = 5 * 60 * 1000; // 5 minutes

const BOOTSTRAP_CONFIG = [
  {
    entityType: ENTITY_TYPES.PRODUCT,
    fetcher: () => productApi.list(),
    staleTime: 10 * 60 * 1000
  },
  {
    entityType: ENTITY_TYPES.CUSTOMER,
    fetcher: () => customersApi.list(),
    staleTime: 10 * 60 * 1000
  },
  {
    entityType: ENTITY_TYPES.MONEY_ACCOUNT,
    fetcher: () => accountsApi.list(),
    staleTime: 5 * 60 * 1000
  },
  {
    entityType: ENTITY_TYPES.ORG_ACCOUNT,
    fetcher: () => businessAccountsApi.list(),
    staleTime: 15 * 60 * 1000
  }
];

export async function bootstrapOfflineData({ user, force = false } = {}) {
  const orgId = user?.orgId || user?.org?.id || null;

  const results = [];

  for (const config of BOOTSTRAP_CONFIG) {
    try {
      const res = await dataService.hydrateCollection(config.entityType, config.fetcher, {
        orgId,
        force,
        staleTime: config.staleTime ?? DEFAULT_STALE_TIME
      });
      results.push({ entityType: config.entityType, ...res });
    } catch (error) {
      console.error('Failed to hydrate entity', config.entityType, error);
      results.push({ entityType: config.entityType, error: error.message });
    }
  }

  if (navigator.onLine || force) {
    await cacheCategories(orgId);
    await cacheOrgProfile();
  }

  return results;
}

async function cacheCategories(orgId) {
  try {
    const [expenseCategories, incomeCategories] = await Promise.all([
      expensesApi.listUnified('expense'),
      expensesApi.listUnified('income')
    ]);

    const combined = [];
    if (Array.isArray(expenseCategories)) {
      combined.push(...expenseCategories.map((cat) => ({ ...cat, type: 'expense' })));
    }
    if (Array.isArray(incomeCategories)) {
      combined.push(...incomeCategories.map((cat) => ({ ...cat, type: 'income' })));
    }

    if (combined.length) {
      await dataService.upsertFromServer(ENTITY_TYPES.CATEGORY, combined, { orgId });
      await dataService.setMetadata('lastSync:categories', { timestamp: Date.now(), count: combined.length });
    }
  } catch (error) {
    console.error('Failed to cache categories', error);
  }
}

async function cacheOrgProfile() {
  try {
    const orgProfile = await orgApi.get();
    if (orgProfile) {
      await dataService.setMetadata('org_profile', {
        ...orgProfile,
        cachedAt: Date.now()
      });
    }
  } catch (error) {
    console.error('Failed to cache org profile', error);
  }
}






